import { FloatingBackButton } from "@components/atoms/FloatingBackButton"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { ChipList } from "@components/layout/ChipList"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { StaggerTransitionRoot } from "@components/motion/Transition"
import { simpleDate } from "@utils/dates"
import { Link } from "eddev/routing"
import { defineView } from "eddev/views"

export default defineView("single-classified", (props) => {
  return (
    <div>
      <StaggerTransitionRoot>
        <div className="grid-auto mt-8 pb-10">
          {/* Media Column */}
          <div className="col-span-12 md:col-span-6 grid-auto">
            <div className="col-span-12 md:col-start-2 md:col-end-7">
              <RouteFlipped flipId={props.classified?.id}>
                <ResponsiveImage {...props.classified?.info?.image!} />
              </RouteFlipped>
            </div>
          </div>

          {/* Content Column */}
          <div className="col-span-12 md:col-span-5 pt-5 md:pt-0">
            <div className="grid-auto">
              <div data-transition="children/fade" className="col-span-12 md:col-span-5">
                <div className="type-title-l-medium">{props.classified?.title}</div>
                <div className="mt-2 type-body-s-roman text-grey-mid flex gap-3 justify-between">
                  {props.classified?.date ? <span>Added {simpleDate(props.classified?.date)}</span> : null}
                  {props.classified?.info?.submittingMember?.name ? (
                    <Link className="hover:underline" href={`/directory/${props.classified.info.submittingMember.databaseId}`}>
                      By {props.classified?.info?.submittingMember?.name}
                    </Link>
                  ) : null}
                </div>
                <ChipList className="mt-2" chips={props.classified?.chips} />
              </div>
              <div className="col-span-12 md:col-span-5 lg:col-span-4">
                <div className="h-5" />
                <div data-transition="children/fade" className="rich-wysiwyg link-styles" dangerouslySetInnerHTML={{ __html: props.classified?.info?.mainDetails! }} />
              </div>
            </div>
          </div>
        </div>
      </StaggerTransitionRoot>
      <FloatingBackButton />
    </div>
  )
})
